module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('router-link', {
    attrs: {
      "to": "/admin/carforsaleaddpre",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Agregar vehiculo")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/admin/inquiryadmin",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Cotizaciones")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/admin/carforsaleadmin",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Vehiculos en venta")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/admin/bankadmin",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Bancos")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/admin/carbrandadmin",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Marcas de vehiculos")])])], 1), _vm._v(" "), _c('hr')])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-355c0147", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-355c0147"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gui/AdminNav.vue
// module id = 114
// module chunks = 0